module.exports = __webpack_public_path__ + "img/zimmer-frei-6.c5ef3b97.jpg";